var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dynamic-page-renderer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoaded),expression:"isLoaded"}],attrs:{"page":_vm.pageProperties},on:{"pageLoaded":_vm.onPageLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }